import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="relative z-10 pt-16 bg-primary bg-opacity-5 md:pt-20 lg:pt-24">
        <div className="container">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full px-4 md:w-1/2 lg:w-4/12 xl:w-5/12">
              <div className="mb-12 max-w-[360px] lg:mb-16">
                <Link to="/" className="inline-block mb-8 ml-10">
                  <img
                    src="/assets/XBA-logo.png"
                    alt="logo"
                    className="hidden w-full dark:block"
                    width={140}
                    height={30}
                  />
                </Link>
                <p className="ml-10 text-base font-medium leading-relaxed text-white mb-9">
                  Connecting Nodes For Seamless Insights
                </p>
                <div className="flex items-center">
                  <a
                    href="https://x.com/X_BOSON_AI?t=fnEmrXlEeQm7_xe3PBk9sg&s=09"
                    aria-label="social-link"
                    className="mr-6 ml-10 text-[#CED3F6] hover:text-primary"
                  >
                    <svg
                      width="19"
                      height="14"
                      viewBox="0 0 19 14"
                      className="fill-current"
                    >
                      <path d="M16.3024 2.26027L17.375 1.0274C17.6855 0.693493 17.7702 0.436644 17.7984 0.308219C16.9516 0.770548 16.1613 0.924658 15.6532 0.924658H15.4556L15.3427 0.821918C14.6653 0.282534 13.8185 0 12.9153 0C10.9395 0 9.3871 1.48973 9.3871 3.21062C9.3871 3.31336 9.3871 3.46747 9.41532 3.57021L9.5 4.0839L8.90726 4.05822C5.29435 3.95548 2.33065 1.13014 1.85081 0.642123C1.06048 1.92637 1.5121 3.15925 1.99194 3.92979L2.95161 5.36815L1.42742 4.5976C1.45565 5.67637 1.90726 6.52397 2.78226 7.14041L3.54435 7.65411L2.78226 7.93665C3.2621 9.24658 4.33468 9.78596 5.125 9.99144L6.16935 10.2483L5.18145 10.8647C3.60081 11.8921 1.625 11.8151 0.75 11.738C2.52823 12.8682 4.64516 13.125 6.1129 13.125C7.21371 13.125 8.03226 13.0223 8.22984 12.9452C16.1331 11.25 16.5 4.82877 16.5 3.54452V3.36473L16.6694 3.26199C17.629 2.44007 18.0242 2.00342 18.25 1.74658C18.1653 1.77226 18.0524 1.82363 17.9395 1.84932L16.3024 2.26027Z" />
                    </svg>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/x-boson-ai/"
                    aria-label="social-link"
                    className="mr-6 ml-2 text-[#CED3F6] hover:text-primary"
                  >
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      className="fill-current"
                    >
                      <path d="M15.2196 0H1.99991C1.37516 0 0.875366 0.497491 0.875366 1.11936V14.3029C0.875366 14.8999 1.37516 15.4222 1.99991 15.4222H15.1696C15.7943 15.4222 16.2941 14.9247 16.2941 14.3029V1.09448C16.3441 0.497491 15.8443 0 15.2196 0ZM5.44852 13.1089H3.17444V5.7709H5.44852V13.1089ZM4.29899 4.75104C3.54929 4.75104 2.97452 4.15405 2.97452 3.43269C2.97452 2.71133 3.57428 2.11434 4.29899 2.11434C5.02369 2.11434 5.62345 2.71133 5.62345 3.43269C5.62345 4.15405 5.07367 4.75104 4.29899 4.75104ZM14.07 13.1089H11.796V9.55183C11.796 8.7061 11.771 7.58674 10.5964 7.58674C9.39693 7.58674 9.222 8.53198 9.222 9.47721V13.1089H6.94792V5.7709H9.17202V6.79076H9.19701C9.52188 6.19377 10.2466 5.59678 11.3711 5.59678C13.6952 5.59678 14.12 7.08925 14.12 9.12897V13.1089H14.07Z" />
                    </svg>
                  </a>
                  <a
                    href="https://youtube.com/@xbosonai?si=LE4llKyZawXw-4Rw"
                    aria-label="social-link"
                    className="mr-6 ml-2 text-[#CED3F6] hover:text-primary"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="fill-current"
                    >
                      <path d="M23.498 6.186c-.264-1.058-1.064-1.91-2.083-1.99-2.96-.173-5.926-.173-8.886-.173-2.959 0-5.926 0-8.886.173-1.018.08-1.818.932-2.083 1.99C0 9.158 0 12 0 12s0 2.842.546 5.814c.264 1.058 1.064 1.91 2.083 1.99 2.96.173 5.926.173 8.886.173 2.959 0 5.926 0 8.886-.173 1.018-.08 1.818-.932 2.083-1.99C24 14.842 24 12 24 12s0-2.842-.546-5.814zM9.545 15.459V8.541l6.058 3.459-6.058 3.459z" />
                    </svg>
                  </a>
                  <a
                    href="https://www.instagram.com/caax_ai?igsh=NHk0aHFtczdwMnI="
                    aria-label="social-link"
                    className="mr-6 ml-2 text-[#CED3F6] hover:text-primary"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="fill-current"
                    >
                      <path d="M7.5 2C4.462 2 2 4.462 2 7.5v9c0 3.038 2.462 5.5 5.5 5.5h9c3.038 0 5.5-2.462 5.5-5.5v-9c0-3.038-2.462-5.5-5.5-5.5h-9zm0 1.5h9c2.213 0 4 1.787 4 4v9c0 2.213-1.787 4-4 4h-9c-2.213 0-4-1.787-4-4v-9c0-2.213 1.787-4 4-4zm7.5 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-1.5 5a3.001 3.001 0 10-3 3 3.001 3.001 0 003-3z" />
                    </svg>
                  </a>
                  <a
                    href="https://www.facebook.com/profile.php?id=61562588471809"
                    aria-label="social-link"
                    className="mr-6 ml-2 text-[#CED3F6] hover:text-primary"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      className="fill-current"
                    >
                      <path d="M21 11.46C21 5.13 16.52 0 11 0S1 5.13 1 11.46c0 5.43 4.23 9.91 9.66 10.43v-7.37H8.59v-3h2.97V10c0-2.93 1.52-4.56 3.93-4.56 1.14 0 2.34.09 2.34.09v2.56h-1.32c-1.3 0-1.71.81-1.71 1.64v2.04h3.1l-.5 3h-2.6v7.37C16.77 21.37 21 16.89 21 11.46z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full px-4 sm:w-1/2 md:w-1/2 lg:w-2/12 xl:w-2/12">
              <div className="mb-12 lg:mb-16">
                <h2 className="mb-10 ml-5 text-xl font-bold text-white">
                  Useful Links
                </h2>
                <ul>
                  <li>
                    <Link
                      to="/enablers"
                      className="inline-block mb-4 ml-5 text-base font-medium text-white hover:text-primary"
                    >
                      About
                    </Link>
                  </li>
                  
                  <li>
                    <Link
                      to="/caax"
                      className="inline-block mb-4 ml-5 text-base font-medium text-white hover:text-primary"
                    >
                      Caax
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/krishisat"
                      className="inline-block mb-4 ml-5 text-base font-medium text-white hover:text-primary"
                    >
                      Krishisat
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/blog"
                      className="inline-block mb-4 ml-5 text-base font-medium text-white hover:text-primary"
                    >
                      Blogs
                    </Link>
                  </li>
                  
                </ul>
              </div>
            </div>

            <div className="w-full px-4 sm:w-1/2 md:w-1/2 lg:w-2/12 xl:w-2/12">
              <div className="mb-12 lg:mb-16">
                <h2 className="mb-10 ml-5 text-xl font-bold text-white">
                  Terms
                </h2>
                <ul>
                  <li>
                    <Link
                      to="/privacy-policy"
                      className="inline-block mb-4 ml-5 text-base font-medium text-white text-body-color hover:text-primary"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="w-full px-4 md:w-1/2 lg:w-4/12 xl:w-3/12">
              <div className="mb-12 lg:mb-16">
                <h2 className="mb-10 ml-5 text-xl font-bold text-white">
                  Support & Help
                </h2>
                <ul>
                  <li>
                    <Link
                      to="/contact"
                      className="inline-block mb-4 ml-5 text-base font-medium text-white hover:text-primary"
                    >
                      Connect with us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* New Address Section */}
            <div className="w-full px-4">
  <div className="mb-12 lg:mb-16">
    <h2 className="mb-10 ml-10 text-white text-m">
      Address : 2nd Floor, Administrative Block, <br />
      Govt Polytechnic College, Koottupaatha, <br/> 
      Palakkad, Kerala 678551 <br/> 
      Mob : +91 7034930530
    </h2>
  </div>
</div>

          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
